var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11020_2594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 35.25C27.5269 35.25 35.25 27.5269 35.25 18C35.25 8.47309 27.5269 0.75 18 0.75C8.47309 0.75 0.75 8.47309 0.75 18C0.75 27.5269 8.47309 35.25 18 35.25Z",
    fill: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7077 26.4391L21.75 23.2501V17.8044H14.25V23.2501L7.29218 26.4391C6.1626 26.9567 5.25027 28.3792 5.25 29.6182C8.40482 33.0784 12.9487 35.2501 18 35.2501C23.0512 35.2501 27.5951 33.0784 30.7499 29.6182C30.7496 28.381 29.8355 26.9559 28.7077 26.4391Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 21.75C14.6863 21.75 12 19.0637 12 15.75V13.5C12 10.1863 14.6863 7.5 18 7.5C21.3137 7.5 24 10.1863 24 13.5V15.75C24 19.0637 21.3137 21.75 18 21.75Z",
    fill: "#E9ECEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11020_2594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPic);
export default __webpack_public_path__ + "static/media/user_pic.e56d78f365921ab509a21ce6c867d9b5.svg";
export { ForwardRef as ReactComponent };